import r from "./index221.mjs";
const t = (o) => r(o) && o !== "classes";
export {
  t as default
};
